/** Shared option arrays for inspection report form fields and alert notification configuration. */

export interface OptionItem {
  label: string;
  value: string;
}

export const conditionOptions: OptionItem[] = [
  { label: 'Good', value: 'good' },
  { label: 'Needs Attention', value: 'needs_attention' },
  { label: 'Requires Service', value: 'requires_service' },
];

export const conditionWithNaOptions: OptionItem[] = [...conditionOptions, { label: 'None', value: 'n_a' }];

export const yesNoOptions: OptionItem[] = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const hvacAgeOptions: OptionItem[] = [
  { label: '1 - 10 Years', value: '1_10' },
  { label: '11 - 15 Years', value: '11_15' },
  { label: '15+ Years', value: '15_plus' },
];

export const plumbingAgeOptions: OptionItem[] = [
  { label: 'None', value: 'n_a' },
  { label: '1 - 6 Years', value: '1_6' },
  { label: '6 - 9 Years', value: '6_9' },
  { label: '10 - 15 Years', value: '10_15' },
];

export const booleanOptions: OptionItem[] = [
  { label: 'Checked', value: 'true' },
  { label: 'Unchecked', value: 'false' },
];

export const hvacSystemTypeOptions: OptionItem[] = [
  { label: 'Split System', value: 'split_system' },
  { label: 'Package Unit', value: 'package_unit' },
  { label: 'Mini Split', value: 'mini_split' },
  { label: 'Boiler', value: 'boiler' },
];

export const splitSystemSubtypeOptions: OptionItem[] = [
  { label: 'Furnace/AC', value: 'furnace_ac' },
  { label: 'Furnace/Heat Pump', value: 'furnace_heat_pump' },
  { label: 'Air Handler/Heat Pump', value: 'air_handler_heat_pump' },
  { label: 'Furnace Only', value: 'furnace_only' },
  { label: 'AC Only', value: 'ac_only' },
];

export const SPLIT_SYSTEM_DUAL_SUBTYPES = new Set(['furnace_ac', 'furnace_heat_pump', 'air_handler_heat_pump']);

// Age bucket -> chip color and auto-filled condition. Keys must match hvacAgeOptions / plumbingAgeOptions values.
export const HVAC_AGE_COLOR_MAP: Record<string, string> = {
  '1_10': '#4caf50',
  '11_15': '#ff9800',
  '15_plus': '#f44336',
};

export const HVAC_AGE_CONDITION_MAP: Record<string, string> = {
  '1_10': 'good',
  '11_15': 'needs_attention',
  '15_plus': 'requires_service',
};

export const PLUMBING_AGE_COLOR_MAP: Record<string, string> = {
  '1_6': '#4caf50',
  '6_9': '#ff9800',
  '10_15': '#f44336',
};

export const PLUMBING_AGE_CONDITION_MAP: Record<string, string> = {
  '1_6': 'good',
  '6_9': 'needs_attention',
  '10_15': 'requires_service',
};

export const PLUMBING_SYSTEM_TYPE_OPTIONS: OptionItem[] = [
  { label: 'Water Heater', value: 'tank_water_heater' },
  { label: 'Tankless Water Heater', value: 'tankless_water_heater' },
];
